import { Button } from "@mui/material";
import { convertToCamelCaseFromUnderScore } from "../../../../common-utilities/utils";
import {
  getPurchaseOrderWithoutTaxAmount,
  getPurchaseOrderTaxAmount,
  getPOGrandTotal,
  getApprovalPOExtraChargesTotal,
  hasPOExtraCharges,
} from "../helper";
import { Checkbox, Tooltip } from "@mui/material";

export const getHeaderConfig = (
  editVendor,
  status,
  loadData,
  handleRowSelection,
  selectedPoList,
  dataList
) => {
  const headers = [
    {
      id: "checkbox",
      label: (
        <Checkbox
          onChange={(event) => handleRowSelection(event, null, "selectAll")}
          checked={
            selectedPoList.length === dataList.length && dataList.length !== 0
          }
        />
      ),
      sortable: false,
      render: (data, index) => {
        return (
          <Checkbox
            checked={
              selectedPoList.find((ele) => ele.id === data.id) ? true : false
            }
            onChange={(event) => handleRowSelection(event, data)}
          />
        );
      },
    },
    {
      label: "PO Number",
      id: "poNumber",
      render: (data) => {
        const { document = {} } = data;
        const { poNumber = "" } = document || {};
        return poNumber;
      },
    },
    {
      label: "Site Code & Name",
      id: "siteCode",
      render: (data) => {
        const { site = {} } = data;
        return (site && `${site.code || ""} - ${site.name || ""} `) || "";
      },
    },
    {
      label: "Billing Location",
      id: "billingLocation",
      render: (data) => {
        const { document = {} } = data;
        const { billingLocationId } = document || {};
        if (!billingLocationId || typeof billingLocationId !== "object") {
          return "-";
        }
        const { code = "", name = "" } = billingLocationId;
        return (code ? `${code} - ${name}` : name) || "-";
      },
    },
    {
      label: "Vendor code",
      id: "vendorCode",
      render: (data) => {
        const { document = {} } = data;
        const { vendorCode = "" } = document || {};
        return vendorCode;
      },
    },
    {
      label: "Vendor Name",
      id: "vendorName",
      render: (data) => {
        const { document = {} } = data;
        const { vendorName = "" } = document || {};
        return vendorName;
      },
    },
    {
      label: "PO Type",
      id: "poType",
      render: (data) => {
        const { document = {} } = data;
        const { poType = "" } = document || {};
        return convertToCamelCaseFromUnderScore(poType);
      },
    },
    {
      label: "Base Amt",
      id: "baseAMount",
      render: (data) => {
        const { document = {} } = data;
        const { items = [] } = document;
        return getPurchaseOrderWithoutTaxAmount(items);
      },
    },
    {
      label: "GST Amt",
      id: "gstAMount",
      render: (data) => {
        const { document = {} } = data;
        const { items = [] } = document;
        return getPurchaseOrderTaxAmount(items);
      },
    },
    {
      label: "Extra Charges Amt",
      id: "extraChargesAmount",
      render: (data) => {
        const { document = {} } = data;
        return hasPOExtraCharges(document || {})
          ? getApprovalPOExtraChargesTotal(document || {})
          : "-";
      },
    },
    {
      label: "Total Amt",
      id: "totalAMount",
      render: (data) => {
        const { document = {} } = data;
        return getPOGrandTotal(document);
      },
    },
    {
      label: "Pending With",
      id: "pendingWith",
    },
    {
      label: "PO Remarks",
      id: "poRemarks",
      render: (data) => {
        const { document = {} } = data;
        const { remarks = "" } = document || {};
        if (!remarks) {
          return "-";
        }
        return (
          <Tooltip
            title={remarks}
            placement="top"
            slotProps={{
              tooltip: {
                sx: {
                  bgcolor: "rgba(33, 33, 33, 0.95)",
                  fontSize: 12,
                  lineHeight: 1.5,
                  maxWidth: 300,
                  padding: "8px 12px",
                },
              },
            }}
          >
            <div
              style={{
                width: 200,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                wordBreak: "break-word",
              }}
            >
              {remarks}
            </div>
          </Tooltip>
        );
      },
    },
    {
      label: "Created By",
      id: "creatorName",
      render: (data) => {
        const { document = {} } = data;
        const { creatorName = "" } = document || {};
        return creatorName;
      },
    },
    {
      label: "Actions",
      id: "actions",
      render: (data) => {
        return (
          <Button variant="text" onClick={() => editVendor(data, "VIEW")}>
            View
          </Button>
        );
      },
    },
  ];
  // Approver view: every row is pending with the logged-in user, so Vendor code / Pending With are redundant.
  const hiddenIds =
    status === "approval_in_progress" ? ["vendorCode", "pendingWith"] : [];
  // dataList is the full pending list: show the column only if some PO in it has extra charges.
  if (!(dataList || []).some((row) => hasPOExtraCharges(row?.document || {}))) {
    hiddenIds.push("extraChargesAmount");
  }
  return headers.filter((header) => !hiddenIds.includes(header.id));
};
